import productService from "../../../../services/ProductService"
import categoryService from "../../../../services/CategoryService"
import Notify from "../../../../elements/Notify"

export default {
   name: 'ProductForm',
   data() {
      return {
         product: {
            id             : null,
            code           : '',
            name           : '',
            src            : '',
            price          : '',
            discount_rate  : 0,
            discount_amount: '',
            sale_price     : '0.00',
            offer_status   : '0',
            status         : true,
            category_id    : '',
            created_at     : '',
         },
         categoryOptions: [],
         oldCategoryId  : '',
         isEdit         : false
      }
   },
   created() {
      this.$store.dispatch('title', 'Formulario de producto')

      categoryService.getRef().on('value', snapshot => {
         this.fillCategorySelect(snapshot.val())
      })

      // eslint-disable-next-line
      if (!!this.$route.params.productId) {
         productService.getProductById(this.$route.params.productId)
            .then((snapshot) => {
               let product = snapshot.val()

               this.product.id              = product.id
               this.product.code            = product.code
               this.product.name            = product.name
               this.product.src             = product.src
               this.product.price           = product.price
               this.product.discount_rate   = product.discount_rate
               this.product.discount_amount = product.discount_amount
               this.product.sale_price      = product.sale_price
               this.product.offer_status    = product.offer_status
               this.product.status          = product.status == '1'
               this.product.category_id     = product.category_id
               this.product.created_at      = product.created_at

               this.oldCategoryId = product.category_id
               this.isEdit = true
               this.$store.dispatch('title', 'Editar producto')
            })
            .catch(() => {
               Notify.error("No existe el producto.")
               this.$router.push({ name: 'products' })
            })
      }
   },
   methods: {
      saveProduct() {
         if (this.isEdit) {
            this.updateProduct()
         }
         else {
            this.newProduct()
         }
      },
      newProduct() {
         let product = this.getProduct()
         productService.storeProduct(product)
            .then(() => {
               Notify.success("Se registro el producto correctamente.")
               this.$router.push({ name: 'products' })
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      updateProduct() {
         let product = this.getProduct()
         productService.updateProduct(product,this.oldCategoryId)
            .then(() => {
               Notify.success("Se actualizó correctamente.")
               this.$router.push({ name: 'products' })
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      getProduct() {
         return {
            id             : this.product.id,
            code           : this.product.code,
            name           : this.product.name,
            src            : this.product.src,
            price          : this.product.price != '' ? parseFloat(this.product.price) : 0,
            discount_rate  : this.product.discount_rate,
            discount_amount: this.product.discount_amount != '' ? parseFloat(this.product.discount_amount) : 0,
            sale_price     : parseFloat(this.product.sale_price),
            offer_status   : this.product.offer_status,
            status         : this.product.status,
            category_id    : this.product.category_id,
            created_at     : this.product.created_at
         }
      },
      fillCategorySelect(data) {
         this.categoryOptions = []
         for (const key in data) {
            if (data.hasOwnProperty(key)) {
               const element = data[key]
               const option = {
                  label: element.name,
                  value: element.id
               }
               this.categoryOptions.push(option)
            }
         }
      },
      syncronizationData() {
         let price = parseFloat(this.product.price)
         let discountAmount = parseFloat(this.product.discount_amount)

         if (this.product.offer_status == "1") {
            let discountRate = discountAmount / price
            discountRate = isFinite(discountRate) ? discountRate : (isNaN(discountRate) ? 0 : 1)

            this.product.discount_rate = parseFloat(discountRate.toFixed(2))

            let salePrice = price - discountAmount;
            salePrice = isNaN(salePrice) ? 0 : salePrice;

            this.product.sale_price = salePrice.toFixed(2);
         }
         else {
            this.product.discount_rate = 0
            this.product.discount_amount = 0
            this.product.sale_price = this.product.price
         }
      }
   },
   computed: {
      discountRate() {
         return "-" + (this.product.discount_rate * 100).toFixed(0) + "%"
      },
      salePrice() {
         return parseFloat(this.product.sale_price).toFixed(2)
      },
      statusText() {
         return this.product.status ? 'Disponible' : 'No disponible'
      },
      textButtonSubmit() {
         return this.isEdit ? 'Guardar' : 'Registrar'
      }
   }
}
